import React from "react";
import { Users } from "lucide-react";

const fundraisingMembers = [
  "Emily Rodriguez",
  "David Kim",
  "Lisa Thompson",
  "James Wilson",
  "Amanda Brown",
];

const FundraisingTeamCard = () => {
  return (
    <div className="card-elevated p-6">
      <div className="flex items-center gap-2 mb-5">
        <div className="w-8 h-8 rounded-lg bg-secondary/10 flex items-center justify-center">
          <Users size={18} className="text-secondary" />
        </div>
        <h3 className="text-lg font-heading font-semibold text-foreground">
          Fundraising Team
        </h3>
      </div>

      <ul className="space-y-3">
        {fundraisingMembers.map((name, index) => (
          <li
            key={index}
            className="flex items-center gap-3 p-3 rounded-lg hover:bg-muted/50 transition-colors"
          >
            <div className="w-8 h-8 rounded-full bg-gradient-to-br from-secondary to-gsg-blue-light flex items-center justify-center text-sm font-semibold text-secondary-foreground">
              {name.charAt(0)}
            </div>
            <span className="text-foreground">{name}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FundraisingTeamCard;
